declare module '@tomandco/nexus-api-types' {
    namespace Nexus.Lib.Basket {
        interface BasketData<
            TItemId extends number | string = number,
            TProductId extends number | string = number,
            TQuoteId extends number | string = number
        > {
            storeCreditMinimumSpend?: number;
        }

        interface Totals {
            credits?: number;
        }
    }
}

declare module '@df/checkout/checkout.interfaces' {
    namespace Checkout {
        interface ICheckoutData {
            store_credit: {
                balance: number;
                // hash: string;
            };
        }
    }
}

declare module '@df/session/customer/customer.interfaces' {
    namespace Customer {
        interface ICustomerData {
            store_credit_balance?: number;
            store_credit_barcode?: string;
            store_credit_code?: string;
            store_credit_history?: StoreCredit.IHistoryItem[];
            store_credit_welcome_offer?: boolean;
        }
    }
}

export namespace StoreCredit {
    export enum Endpoints {
        MergeGiftcard = 'giftcard/transfer',
        SendEmail = 'giftcard/email',
        Apply = 'giftcard/applyStoreCredit',
        Remove = 'giftcard/removeStoreCredit',
        CheckoutApply = 'checkout/giftcardApplyStoreCredit',
        CheckoutRemove = 'checkout/giftcardRemoveStoreCredit'
    }

    export interface IMergeCardData {
        // gift card code
        code: string;
        // gift card pin
        pin: string;
    }

    export interface IHistoryItem {
        action?: string;
        amount: number;
        created_at: string;
        note?: string;
        order_id: string | number | null;
        order_increment_id: string | number | null;
        return_reason_code?: string;
    }
}
